<p-dialog
  [header]="getDialogHeader()"
  i18n-header="Region dialog header@@regionDialogHeader"
  [(visible)]="visible"
  [style]="{width: '50vw'}"
  [modal]="true"
  [closable]="false"
  [draggable]="false">

  <form [formGroup]="regionForm" (ngSubmit)="onSubmit()">
    <app-input
      label="Region Name"
      i18n-label="Region name label@@regionNameLabel"
      formControlName="name"
      [touched]="regionForm.get('name')?.touched"
      [errorMessage]="regionForm.get('name')?.errors"
      [required]="true"
    >
    </app-input>

    <div class="p-dialog-footer">

      <button
        pButton
        type="button"
        (click)="onCancel()"
        label="Cancel"
        i18n-label="@@cancelButton"
        class="p-button-text">
      </button>

      <button
        *ngIf="isNewRegion"
        pButton
        type="submit"
        label="Create"
        i18n-label="@@createRegionButton"
        class="p-button-block"
        [disabled]="regionForm.invalid">
      </button>

      <button
        *ngIf="!isNewRegion"
        pButton
        type="submit"
        [label]="isNewRegion ? 'Create' : 'Save'"
        i18n-label="Create or save region button@@createSaveRegionButton"
        class="p-button-block"
        [disabled]="regionForm.invalid">
      </button>

    </div>
  </form>
</p-dialog>